import { gql } from '@apollo/client'

export const RETRIEVE_CAFE_CONFIG = gql`
    query RetrieveCafe($cafeId: Int) {
        retrieveCafe(id: $cafeId) {
            result
            error
            cafe {
                id
                name
                note
                stalls {
                    id
                    name
                    note
                    vendorId
                }
                tables {
                    id
                    name
                    note
                }
                cashRegisters {
                    id
                    name
                    note
                }
            }
        }
    }
`

export const RETRIEVE_CAFE_CASH_REGISTERS = gql`
    query RetrieveCafeCashRegisters($cafeId: Int) {
        retrieveCafeCashRegisters(cafeId: $cafeId) {
            id
            cafeId
            name
            note
        }
    }
`

export const RETRIEVE_CAFE_GROUPS = gql`
    query RetrieveCafeGroups($cafeId: Int) {
        retrieveCafeGroups(cafeId: $cafeId) {
            id
            type
            name
        }
    }
`

export const RETRIEVE_MENUS = gql`
    query RetrieveMenus($input: MenuInput!) {
        retrieveMenus(input: $input) {
            result
            error
            menus {
                id
                dishId
                name
                description
                note
                stallId
                stallName
                vendorId
                vendorName
                createdAt
                updatedAt
                openTimes {
                    name
                    times {
                        open
                        close
                    }
                }
                sessions {
                    id
                    name
                }
                variants {
                    id
                    name
                    price
                    sellPrice
                    inventory {
                        id
                        status
                        initialQuantity
                        orderedQuantity
                    }
                    selections {
                        id
                        name
                        type
                        quantity
                        isRequired
                        options {
                            id
                            name
                            sellPrice
                            maxQuantity
                            inventory {
                                id
                                status
                                initialQuantity
                                orderedQuantity
                            }
                        }
                    }
                }
            }
            pageInfo {
                totalCount
                currentPage
                totalPages
                hasNextPage
                hasPreviousPage
            }
        }
    }
`

export const CREATE_ORDER = gql`
    mutation CreateOrder($input: CreateOrderInput!) {
        createOrder(input: $input) {
            result
            error
            order {
                orderId
                number
                cafeId
                table {
                    id
                    name
                    note
                }
                status
                payment {
                    id
                    type
                    paymentIntentId
                    clientSecret
                }
                createdOn
                createdBy
                updatedOn
                updatedBy
                note
                isDineIn
                summary {
                    originalAmount
                    benefitDiscount
                    creditDiscount
                    finalAmount
                }
                dishes {
                    id
                    dishId
                    name
                    cafeMenuId
                    cafeStallId
                    cafeId
                    note
                    selections {
                        id
                        name
                        type
                        quantity
                        options {
                            id
                            name
                            sellPrice
                            quantity
                        }
                    }
                    variants {
                        id
                        variantId
                        name
                        price
                        sellPrice
                        quantity
                        completedAt
                    }
                }
            }
        }
    }
`

export const RETRIEVE_ORDERS = gql`
    query RetrieveOrders($input: RetrieveOrderInput!) {
        retrieveOrders(input: $input) {
            result
            error
            orders {
                orderId
                number
                cafeId
                table {
                    id
                    name
                    note
                }
                status
                payment {
                    id
                    type
                    paymentIntentId
                    clientSecret
                    paidAt
                }
                createdOn
                createdBy
                updatedOn
                updatedBy
                note
                isDineIn
                summary {
                    originalAmount
                    benefitDiscount
                    creditDiscount
                    finalAmount
                }
                dishes {
                    id
                    dishId
                    name
                    cafeMenuId
                    cafeStallId
                    cafeStallName
                    vendorId
                    vendorName
                    cafeId
                    note
                    selections {
                        id
                        name
                        type
                        quantity
                        options {
                            id
                            name
                            sellPrice
                            quantity
                        }
                    }
                    variants {
                        id
                        variantId
                        name
                        price
                        sellPrice
                        quantity
                        completedAt
                    }
                }
            }
        }
    }
`

export const CHECK_INVENTORY_STATUS = gql`
    query CheckInventoryStatus($ids: [Int]!) {
        checkInventoryStatus(ids: $ids) {
            result
            error
            inventories {
                id
                status
                initialQuantity
                orderedQuantity
            }
        }
    }
`

export const CREATE_PAYMENT_INTENT = gql`
    mutation CreatePaymentIntent($input: CreatePaymentIntentInput!) {
        createPaymentIntent(input: $input) {
            result
            error
            paymentIntent {
                id
                amount
                currency
                status
                metadata {
                    orderId
                }
                client_secret
                created
                updated
            }
        }
    }
`

export const CHECK_ORDER_PAYMENT_STATUS = gql`
    query CheckOrderPaymentStatus($orderId: String!) {
        checkOrderPaymentStatus(orderId: $orderId) {
            result
            error
            order {
                orderId
                number
                status
                payment {
                    id
                    type
                    paymentIntentId
                    paidAt
                }
                createdOn
                createdBy
                updatedOn
                updatedBy
                note
                isDineIn
                summary {
                    originalAmount
                    benefitDiscount
                    creditDiscount
                    finalAmount
                }
            }
        }
    }
`
